import React from 'react';
import { useHistory } from 'react-router-dom';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

const NoAccess = () => {      
    
    const history = useHistory();

    const handleTryLogin = () => {
        history.push('/login');
    };

    const handleGetStarted = () => {
        history.push('/onboarding/platform');
    };

    return (
        <>
            <div className="pt-5">    
                <Row className="primary-font-color" style={{ paddingTop:"50px", paddingBottom: "20px", overflow:"hidden" }}>
                    <Col xs={1}></Col>
                    <Col xs={10}>       
                            
                        {/* Page Header */}
                        <Row style={{ marginBottom: "32px" }}>
                            <Col xs={12}>
                                <h1 style={{ 
                                    color: "#FFFFFF", 
                                    fontSize: "clamp(1.75rem, 4vw, 2.5rem)", 
                                    fontWeight: "700",
                                    margin: 0,
                                    textAlign: "center"
                                }}>
                                    We couldn't log you in
                                </h1>
                            </Col>
                        </Row>                        
                        
                        {/* Single Card */}
                        <Row>
                            <Col xs={12} md={10} lg={10} className="mx-auto p-0">
                                <Card style={{
                                    background: "rgba(30, 41, 59, 0.95)",
                                    backdropFilter: "blur(20px)",
                                    border: "1px solid rgba(255, 255, 255, 0.4)",
                                    borderRadius: "16px",
                                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)"
                                }}>
                                    <Card.Body style={{ 
                                        padding: "clamp(1.5rem, 4vw, 2rem)",
                                        textAlign: "center"
                                    }}>
                                        <div style={{ marginBottom: "24px" }}>                                            
                                            <p style={{
                                                color: "#E0E0E0",
                                                fontSize: "clamp(0.95rem, 2.5vw, 1rem)",
                                                margin: 0,
                                                lineHeight: "1.6"
                                            }}>
                                                The magic link could be expired or you don't have an account with that email address.
                                            </p>
                                        </div>
                                        
                                        <div style={{ 
                                            display: "flex", 
                                            flexDirection: "column", 
                                            gap: "clamp(0.75rem, 2vw, 1rem)",
                                            maxWidth: "400px",
                                            margin: "0 auto"
                                        }}>
                                            <Button 
                                                onClick={handleTryLogin}
                                                variant="outline-light"
                                                style={{
                                                    fontSize: "clamp(0.95rem, 2.5vw, 1rem)",
                                                    fontWeight: "600",
                                                    padding: "clamp(12px, 3vw, 16px) clamp(20px, 4vw, 24px)",
                                                    borderRadius: "8px",
                                                    transition: "all 0.2s ease-in-out",
                                                    width: "100%",
                                                    minHeight: "48px"
                                                }}
                                            >
                                                Login
                                            </Button>
                                            
                                            <Button 
                                                onClick={handleGetStarted}
                                                className="btn-primary-gradient"
                                                style={{
                                                    fontSize: "clamp(0.95rem, 2.5vw, 1rem)",
                                                    fontWeight: "600",
                                                    padding: "clamp(12px, 3vw, 16px) clamp(20px, 4vw, 24px)",
                                                    borderRadius: "8px",
                                                    transition: "all 0.2s ease-in-out",
                                                    width: "100%",
                                                    minHeight: "48px"
                                                }}
                                            >
                                                Get Started →
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        
                    </Col>                            
                </Row>
            </div>
        </>
    );
};

export default NoAccess;
